import { c as _c } from "react/compiler-runtime";
import type { ProfileActivityLog } from "@/entities/IProfile";
import ProfileActivityLogsItem from "./ProfileActivityLogsItem";
import ProfileActivityLogItemWrapper from "./items/utils/ProfileActivityLogItemWrapper";
export default function UserPageIdentityActivityLogList(t0) {
  const $ = _c(7);
  const {
    logs,
    user
  } = t0;
  let t1;
  if ($[0] !== logs || $[1] !== user) {
    let t2;
    if ($[3] !== user) {
      t2 = log => <ProfileActivityLogItemWrapper key={log.id} log={log} user={user}><ProfileActivityLogsItem log={log} user={user} /></ProfileActivityLogItemWrapper>;
      $[3] = user;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    t1 = logs.map(t2);
    $[0] = logs;
    $[1] = user;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[5] !== t1) {
    t2 = <div className="tw-mt-4 md:tw-mt-6"><div className="tw-space-y-2.5">{t1}</div></div>;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
}